class RendererRoutePaths {
  static IMAGES_ADVERT = '/item';
  static IMAGES_CAROUSEL_ITEM = '/carousel-item';
}

export default RendererRoutePaths;
